export default __webpack_public_path__ + "landingpage.png";